/**
 * API client configuration.
 * baseURL must be set via env (e.g. REACT_APP_API_BASE_URL) – no hardcoded URLs.
 */
export const apiConfig = {
  baseURL: process.env.REACT_APP_API_BASE_URL ?? '',
  timeout: 30000,
  headers: {
    Accept: 'application/json',
  },
} as const;

export const AUTH_TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const AUTH_USER_KEY = 'user';
export const AUTH_LOGGED_IN_KEY = 'isLoggedIn';
